import { StringUtils } from '../../shared/utils/string.utils';

export interface MpAuthInfo {
  access_token: string;
  customerId: number;
  customerName: string;
  userId: number;
  email: string;
  classIds: number[];
  userFirstName: string;
  userLastName: string;
  closeTabOnLogout: boolean;
  showStudentMaps?: boolean;
  showCoachContent?: boolean;
  showReadingStandards?: boolean;
  enableK1Dashboard?: boolean;
  allowImpersonate?: boolean;
  trialDaysRemaining?: number;
  isddguser?: boolean;
  studioLessonActiveDemoMode?: boolean;
}

export namespace MpAuthInfo {
  export function getMpAuthInfo(token: string, overrideCustomerId: number): MpAuthInfo {
    const parsedToken = StringUtils.parseJwt(token);
    return {
      access_token: token,
      customerId: overrideCustomerId ? overrideCustomerId : +parsedToken['customerId'],
      customerName: parsedToken['customerName'],
      userFirstName: parsedToken['userFirstName'],
      userLastName: parsedToken['userLastName'],
      userId: +parsedToken['userId'],
      email: parsedToken['email'],
      classIds: parsedToken['classes'] ? JSON.parse(parsedToken['classes']) : [],
      closeTabOnLogout:
        parsedToken['closeTab'] && parsedToken['closeTab'] === 'True',
      showCoachContent:
        parsedToken['showCoachContent'] &&
        parsedToken['showCoachContent'] === 'True',
      showReadingStandards:
        parsedToken['showReadingStandards'] &&
        parsedToken['showReadingStandards'] === 'True',
      showStudentMaps:
        parsedToken['showStudentMaps'] && parsedToken['showStudentMaps'] === 'True',
      enableK1Dashboard: parsedToken['enableK1Dashboard'] && parsedToken['enableK1Dashboard'] === 'True',
      allowImpersonate:
        parsedToken['allowImpersonate'] &&
        parsedToken['allowImpersonate'] === 'True',
      trialDaysRemaining:
        parsedToken['trialDaysRemaining'] === ''
          ? null
          : Math.max(0, Number.parseInt(parsedToken['trialDaysRemaining'])),
      isddguser: parsedToken['isddguser'] && parsedToken['isddguser'] === 'True',
      studioLessonActiveDemoMode: parsedToken['studioLessonActiveDemoMode'] && parsedToken['studioLessonActiveDemoMode'] === 'True', // is currently for restricted testing in QA  mode
    }
  }
}
